import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import tunjanganLainService from "../../services/tunjanganLainService";
import Cookies from "js-cookie";

export const initialState = {
    loading_tunjangan_lain: false,
    data_tunjangan_lain: [],
    data_import: [],
    showMessage:false,
    message:'',
}


export const getDataTunjanganLain = createAsyncThunk('tunjangan/data',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganLainService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('tunjangan/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganLainService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('tunjangan/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganLainService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('tunjangan/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await tunjanganLainService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const tunjanganLainSlice = createSlice({
    name: 'tunjangan_lain',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_tunjangan_lain = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataTunjanganLain.fulfilled, (state, action) => {
                state.loading_tunjangan_lain = false
                state.data_tunjangan_lain = action.payload??[]
            })
            .addCase(getDataTunjanganLain.pending, (state) => {
                state.loading_tunjangan_lain = true
            })
            .addCase(getDataTunjanganLain.rejected, (state, action) => {
                state.loading_tunjangan_lain = false
                state.data_tunjangan_lain = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_tunjangan_lain = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_tunjangan_lain = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_tunjangan_lain = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = tunjanganLainSlice.actions

export default tunjanganLainSlice.reducer
